import { render, staticRenderFns } from "./YesNoInput.vue?vue&type=template&id=cb1ea1dc&scoped=true&"
import script from "./YesNoInput.vue?vue&type=script&lang=js&"
export * from "./YesNoInput.vue?vue&type=script&lang=js&"
import style0 from "./YesNoInput.vue?vue&type=style&index=0&id=cb1ea1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ea1dc",
  null
  
)

export default component.exports